import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import './Menu.css';

import { logout } from "../login/loginSlice";
import { clearAccounts } from "../manageAccounts/accountsSlice";
import { selectMenuActive, toggleActive } from "./menuSlice";
import { clearUsers } from "../manageUsers/manageUsersSlice";
import { clearNewTransaction, clearTransactions } from "../transactionList/transactionsSlice";
import { clearUser } from "../home/userSlice";
import { clearBankSettings } from "../manageBankSettings/bankSettingsSlice";
import { clearBranches } from "../manageBranches/branchesSlice";
import { clearSupportTickets } from "../supportTickets/supportTicketsSlice";

export default function Menu() {
    const dispatch = useDispatch();

    const isMenuActive = useSelector(selectMenuActive);

    const handleLogout = () => {
        if (isMenuActive) {
            dispatch(toggleActive());
        }
        dispatch(logout());
        dispatch(clearUser());
        dispatch(clearAccounts());
        dispatch(clearUsers());
        dispatch(clearNewTransaction());
        dispatch(clearTransactions());
        dispatch(clearBankSettings());
        dispatch(clearBranches());
        dispatch(clearSupportTickets());
    }

    return (
        <div className="menu">
            <Link to={`../settings`} style={{width: '100%'}}><button className="menu-button">Settings</button></Link>
            <button className="menu-button" onClick={handleLogout}>Logout</button>
        </div>
    )
}